import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Formik, FormikValues } from 'formik';
import * as Yup from 'yup';

import createTeacher from '../../../lib/apiClient/teachers/create';
import { selectSchools } from '../../../redux/reducers/SchoolsReducer';

import FormikInputField from '../../common/ui/FormikInputField/Input';
import PopupForm from '../../common/ui/PopupForm/Form';
import PopupFormHeader from '../../common/ui/PopupForm/Header';
import PopupFormErrorMessage from '../../common/ui/PopupForm/ErrorMessage';
import Button from '../../common/ui/Button/Button';
import Search from '../../common/ui/Search/Search';

interface Props {
  onClose(): void;
}

const CreateTeacherForm = ({ onClose }: Props) => {
  const [error, setError] = useState<string | null>(null);

  const schools = Object.values(useSelector(selectSchools));
  const schoolsNames = schools.map(({ name }) => name);

  const initialValues = { username: '', password: '', school: '' };

  const validationSchema = Yup.object({
    username: Yup.string()
      .min(4, 'Минимальная длина - 4 символа')
      .max(255, 'Максимальная длина - 255 символов')
      .required('Обязательное поле'),
    password: Yup.string()
      .min(6, 'Минимальная длина - 6 символов')
      .max(255, 'Максимальная длина - 255 символов')
      .required('Обязательное поле'),
    school: Yup.string()
      .oneOf(schoolsNames, 'Указанной школы не существует')
      .required('Обязательное поле'),
  });

  const submit = async ({ username, password, school }: FormikValues) => {
    try {
      const schoolId = schools.find(
        ({ name: schoolName }) => schoolName === school,
      )?.id!;
      await createTeacher({ username, password, schoolId });
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={submit}
    >
      <PopupForm close={onClose} closable>
        <PopupFormHeader>
          Добавление учителя
          <PopupFormErrorMessage text={error ?? ''} visible={error !== null} />
        </PopupFormHeader>

        <FormikInputField
          name="username"
          placeholder="Логин"
          onFocus={() => setError(null)}
        />

        <FormikInputField
          name="password"
          type="password"
          placeholder="Пароль"
          onFocus={() => setError(null)}
        />

        <Search
          name="school"
          placeholder="Школа"
          options={schoolsNames}
          onFocus={() => setError(null)}
        />

        <Button type="submit">Подтвердить</Button>
      </PopupForm>
    </Formik>
  );
};

export default CreateTeacherForm;
